if (!customElements.get('article-editorial-gallery')) {
  customElements.define('article-editorial-gallery', class extends HTMLElement {
    connectedCallback() {
      if (!this.hasAttribute('data-carousel')) return;
      this.track = this.querySelector('.aeg-track');
      this.previous = this.querySelector('.aeg-prev');
      this.next = this.querySelector('.aeg-next');
      if (!this.track) return;
      this.pagination = this.querySelector('.aeg-pagination');
      this.dots = [...this.querySelectorAll('.aeg-dot')];

      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.previous?.addEventListener('click', () => this.move(-1), options);
      this.next?.addEventListener('click', () => this.move(1), options);
      this.dots.forEach((dot, index) => {
        dot.addEventListener('click', () => this.goTo(index), options);
      });
      this.track.addEventListener('scroll', () => this.updateControls(), { ...options, passive: true });
      this.addEventListener('shopify:block:select', event => {
        const slide = event.target.closest('.aeg-item');
        if (slide) slide.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'instant' });
      }, options);
      this.observer = new ResizeObserver(() => this.updateControls());
      this.observer.observe(this.track);
      this.updateControls();
    }

    disconnectedCallback() {
      this.events?.abort();
      this.observer?.disconnect();
    }

    move(direction) {
      const slide = this.track.firstElementChild;
      if (!slide) return;
      const styles = getComputedStyle(this.track);
      const step = slide.getBoundingClientRect().width + (parseFloat(styles.columnGap) || 0);
      this.track.scrollBy({
        left: direction * step * (styles.direction === 'rtl' ? -1 : 1),
        behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
      });
    }

    goTo(index) {
      const slide = this.track.children[index];
      if (!slide) return;
      const styles = getComputedStyle(this.track);
      const step = slide.getBoundingClientRect().width + (parseFloat(styles.columnGap) || 0);
      this.track.scrollTo({
        left: index * step * (styles.direction === 'rtl' ? -1 : 1),
        behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
      });
    }

    updateControls() {
      const max = this.track.scrollWidth - this.track.clientWidth;
      const position = Math.abs(this.track.scrollLeft);
      if (this.previous) {
        this.previous.hidden = max <= 1;
        this.previous.disabled = position <= 1;
      }
      if (this.next) {
        this.next.hidden = max <= 1;
        this.next.disabled = position >= max - 1;
      }
      if (this.pagination) {
        this.pagination.hidden = max <= 1;
        const slide = this.track.firstElementChild;
        const step = slide.getBoundingClientRect().width + (parseFloat(getComputedStyle(this.track).columnGap) || 0);
        const current = Math.min(this.dots.length - 1, Math.round(position / (step || 1)));
        this.dots.forEach((dot, index) => dot.setAttribute('aria-current', String(index === current)));
      }
    }
  });
}
